import { type ProductOption } from "../fixed-charges-edit-table-types/product-option-type";
import { PRODUCT_OPTION_TYPE } from "../fixed-charges-edit-table-types/product-option-type";

export function isAddProduct(option: ProductOption): boolean {
    return option.type === PRODUCT_OPTION_TYPE.ADD_PRODUCT;
}